import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getColor} from "helpers/chartcolors"; // Importing getColor function from helpers for color management
import {devConfig} from "config/config"; // Importing development configuration settings

/**
 * Class representing a view for new players.
 * @extends JetView
 */
export default class jugadoresNuevosView extends JetView {
	/**
	 * Configures the layout of the view.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for internationalization
		var dataset = [ // Data set for the chart
			{ id:1, number:21879, mens:"Depositos"}, // Data point for deposits
			{ id:2, number:8611, mens:"Retiros"}, // Data point for withdrawals
			{ id:3, number:13268, mens:"Neto"} // Data point for net values
		];
		return {
		  rows:[
		    {
		      cols:[
		        {
		          view:"chart", // Chart view configuration
							id:"chartJugNuevos", // Unique identifier for the chart
		          type:"bar", // Type of chart
		          value:"#number#", // Value to be displayed on the chart
		          label:"#number#", // Label for the chart bars
		          barWidth:95, // Width of the bars in the chart
		          radius:3, // Corner radius of the bars
		          gradient:"falling", // Gradient style for the bars
		          data: dataset, // Data set to be used in the chart
							yAxis:{}, // Configuration for the Y-axis
							 xAxis:{
								 lines:true, // Display lines on the X-axis
								 title:"JUGADORES NUEVOS", // Title for the X-axis
								 template:"#mens#" // Template for displaying labels on the X-axis
							 },
							 padding:{
						    left:50, // Left padding for the chart
						    bottom: 50 // Bottom padding for the chart
						  },
						  color:"#bda055" // Color of the chart bars
		        }
		      ]
		    }
		  ]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init(){
		this.on(this.app,"dateDashboard:date",date => { // Listening for date change events
			var dateRange=date; // Storing the date range from the event
			webix.ajax().headers({ // Making an AJAX request to fetch new players data
					"Content-type": "application/json" // Setting the content type for the request
			}).post(devConfig.geturlApi() + "Agent/GetJugadoresNuevos", dateRange, { // Sending the request to the API
					error: function (text, data, XmlHttpRequest) { // Error handling for the AJAX request
							webix.message("Error! "); // Displaying an error message
					},
					success: function (text, data, XmlHttpRequest) { // Success handling for the AJAX request
							var data= JSON.parse((text)); // Parsing the response data
							$$("chartJugNuevos").parse(data); // Parsing the data into the chart
					}
			});
		});
	}
}

// FILE DOCUMENTED
